import { call, put, takeLatest } from "redux-saga/effects";
import { Action } from "../../../actions/actions";
import { API } from "../../../api/api";
import { ConfigurationsActionTypes } from "../actions/actionTypes";
import { configurationsAPI } from "../api/api";

function* getHallBasicInfo(action: Action) {
    try {
        const server = yield call(() =>
            configurationsAPI.getServer({ serverId: action.payload.serverId })
        );

        const basicInfo = yield call(() =>
            configurationsAPI.getHallInfo({ hallId: server.data.hall_id })
        );

        yield put({
            type: ConfigurationsActionTypes.GET_HALL_BASIC_INFO_SUCCESS,
            payload: basicInfo.data
        });

        yield put({
            type: ConfigurationsActionTypes.GET_DENOMINATIONS,
            payload: {
                countryCode: basicInfo.data.subsidiary.country.code
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting Basic Hall Information");

        yield put({
            type: ConfigurationsActionTypes.GET_HALL_BASIC_INFO_FAIL,
            payload: e
        });
    }
}

export function* getHallBasicInfoWatcher() {
    yield takeLatest(
        ConfigurationsActionTypes.GET_HALL_BASIC_INFO,
        getHallBasicInfo
    );
}
